module.exports = __webpack_public_path__ + "img/Icon_Cancel.1d6ef764.svg";